import { render, staticRenderFns } from "./DocumentsCreatePE.vue?vue&type=template&id=a83d6fb6&scoped=true"
import script from "./DocumentsCreatePE.vue?vue&type=script&lang=js"
export * from "./DocumentsCreatePE.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCreatePE.vue?vue&type=style&index=0&id=a83d6fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83d6fb6",
  null
  
)

export default component.exports